import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root',
})
export class ProcurementService {
  environment = EnvironmentService.environment;

  public pmsActionCellSubject: Subject<any> = new Subject();
  public promoSetupActionSubject: Subject<any> = new Subject();
  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setPMSGridActionCellSubject = (value: any) => {
    this.pmsActionCellSubject.next(value);
  };
  //setPromoGridActionCellSubject = (value: any) => { this.promoGridActionCellSubject.next(value); };
  // Observables
  getPMSGridActionCellSubject = () => this.pmsActionCellSubject.asObservable();
  constructor(private httpClient: HttpClient) { }
  addItem(obj = {}) {
    return this.httpClient.post(`${this.environment.PMS}/Item/ItemAdd`, obj);
  }
  updateItem(obj = {}) {
    return this.httpClient.put(`${this.environment.PMS}/Item/ItemUpdate`, obj);
  }
  getItemById(id: number) {
    return this.httpClient.get(`${this.environment.PMS}/Item/ItemGet?ItemId=${id}`);
  }
  getItemsListing(ItemName = '', purchaseTypeDescription = '') {
    // PurchaseTypeId = "",
    // if (PurchaseTypeId === "") {
    //   purchaseTypeDescription = PurchaseTypeId;
    // }
    return this.httpClient.get(
      `${this.environment.PMS}/Item/ItemGetList?ItemName=${ItemName}&PurchaseTypeDescription=${purchaseTypeDescription}`
    );
  }
  addLocation(obj: any = {}) {
    return this.httpClient.post(`${this.environment.PMS}/Location/LocationAdd`, obj);
  }
  updateLocation(obj: any = {}) {
    return this.httpClient.put(
      `${this.environment.PMS}/Location/LocationUpdate`,
      obj
    );
  }
  getLocationById(id: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/Location/LocationGet?LocationId=${id}`
    );
  }
  getLocationsListing(LocationName: string = '', CurrencyCode: string = '') {
    return this.httpClient.get(
      `${this.environment.PMS}/Location/LocationGetList?LocationName=${LocationName}&CurrencyCode=${CurrencyCode}`
    );
  }
  addVendor(obj = {}) {
    return this.httpClient.post(`${this.environment.PMS}/Vendor/VendorAdd`, obj);
  }
  addVendorEvalution(obj = {}) {
    return this.httpClient.post(
      `${this.environment.PMS}/Vendor/VendorEvalutionAdd`,
      obj
    );
  }
  updateVendor(obj: any = {}) {
    return this.httpClient.put(`${this.environment.PMS}/Vendor/VendorUpdate`, obj);
  }
  getVendorById(id: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/Vendor/VendorGet?VendorId=${id}`
    );
  }
  getVendorByPRId(prId: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/Vendor/VendorGetByPrId?PRId=${prId}`
    );
  }
  getVendorEvaluation(id: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/Vendor/VendorEvaluationGet?VendorId=${id}`
    );
  }
  getVendorsListing(VendorName: any = null, VendorEmail: any = null, NTNNumber: any = null) {
    return this.httpClient.get(
      `${this.environment.PMS}/Vendor/VendorGetList?VendorName=${VendorName}&NTNNumber=${NTNNumber}&VendorEmail=${VendorEmail}`
    );
  }
  getPurchaseRequestsListing(prTitle: string, statusDescription: string) {
    return this.httpClient.get(
      `${this.environment.PMS}/PurchaseRequest/PurchaseRequestGetList?PRTitle=${prTitle}&StatusDescription=${statusDescription}`
    );
  }
  getPurchaseRequestsApproveList(prTitle: string, statusDescription: string) {
    return this.httpClient.get(
      `${this.environment.PMS}/PurchaseRequest/PurchaseRequestApproveGetList?PRTitle=${prTitle}&StatusDescription=${statusDescription}`
    );
  }
  addPurchaseRequest(body: any) {
    return this.httpClient.post(
      `${this.environment.PMS}/PurchaseRequest/PurchaseRequestAdd`,
      body
    );
  }
  addPrItem(body: any) {
    return this.httpClient.post(`${this.environment.PMS}/PRItem/PRItemAdd`, body);
  }
  getPRItemGetListbyId(id: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/PRItem/PRItemGetList?PRId=${id}`
    );
  }
  getBidListById(id: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/Bid/BidGetByPRId?PRId=${id}`
    );
  }
  getRequirementsLookup() {
    return this.httpClient.get(`${this.environment.PMS}/Lookup/RequirementTypeGet`);
  }
  getStatusLookup() {
    return this.httpClient.get(`${this.environment.PMS}/Lookup/StatusGet`);
  }
  getPurchaseTypeList() {
    return this.httpClient.get(`${this.environment.PMS}/Lookup/PurchaseTypeGet`);
  }
  uploadDocument(data: any) {
    return this.httpClient.post(
      `${this.environment.PMS}/PurchaseRequest/uploaddoc`,
      data
    );
  }
  UpdatePurchaseRequestUpdateStatus(data: any) {
    return this.httpClient.put(
      `${this.environment.PMS}/PurchaseRequest/PurchaseRequestStatusUpdate`,
      data
    );
  }
  getGRNList() {
    return this.httpClient.get(`${this.environment.PMS}/GRN/GRNGetList`);
  }
  getGRNItems(prId: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/GRN/GetGRNItems?PRId=${prId}`
    );
  }
  getGRNAwaitingList(prTitle: string, statusDescription: string) {
    return this.httpClient.get(
      `${this.environment.PMS}/GRN/GetAwaitingGRN?PRTitle=${prTitle}&GRNStatus=${statusDescription}`
    );
  }
  addGRN(body: any) {
    return this.httpClient.post(`${this.environment.PMS}/GRN/GRNAdd`, body);
  }
  uploadGRNDocument(data: any) {
    return this.httpClient.post(`${this.environment.PMS}/GRN/uploadimage`, data);
  }
  getPurchaseOrdersListing(prTitle: string, statusDescription: string) {
    return this.httpClient.get(
      `${this.environment.PMS}/PurchaseOrder/PurchaseOrderGetList?PRTitle=${prTitle}&StatusDescription=${statusDescription}`
    );
  }
  addPurchaseOrder(body: any) {
    return this.httpClient.post(
      `${this.environment.PMS}/PurchaseOrder/PurchaseOrderAdd`,
      body
    );
  }
  updatePurchaseOrder(body: any) {
    return this.httpClient.put(
      `${this.environment.PMS}/PurchaseOrder/PurchaseOrderUpdate`,
      body
    );
  }
  getPurchaseOrderSummary(prId: number) {
    return this.httpClient.get(
      `${this.environment.PMS}/PurchaseOrder/PurchaseOrderSummaryGet?PRId=${prId}`
    );
  }
  addBidAll(body: any) {
    return this.httpClient.post(`${this.environment.PMS}/Bid/BidAdd`, body);
  }
  updateBidAll(body: any) {
    return this.httpClient.post(`${this.environment.PMS}/Bid/BidUpdateAll`, body);
  }
  UpdateBidUpdateStatus(data: any) {
    return this.httpClient.put(`${this.environment.PMS}/Bid/BidActivate`, data);
  }
}
